export const SIGNUP_STEP1 = "SIGNUP_STEP1";
export const SIGNUP_STEP2 = "SIGNUP_STEP2";
export const LOGIN = "LOGIN";
export const REGISTER_USER = "REGISTER_USER";
